/**
 * Дата начала обучения: перевод между полем «дата» и временем на сервере.
 *
 * ⚠️ ДВЕ ПРИЧИНЫ, ПОЧЕМУ ЭТО ОТДЕЛЬНЫЙ ФАЙЛ С ПРОВЕРКАМИ.
 *
 * ⚠️ ЧАС ОТКРЫТИЯ СТАВИТ СЕРВЕР, А НЕ ЭТОТ ФАЙЛ. Обучение начинается в 6 утра
 * по Казахстану; правило живёт в `courses-service/internal/handler/course_start.go`
 * в одном экземпляре. Здесь только ОБРАТНЫЙ перевод — показать в поле формы тот
 * день, который увидит ученик.
 *
 * ⚠️ День считаем по Казахстану, а не по поясу браузера: у администратора в
 * другом поясе наивное чтение показало бы соседние сутки.
 */

/** Казахстан весь в одном поясе, UTC+5. */
const KZ_OFFSET_HOURS = 5;

/**
 * Обратно для поля формы: «2026-09-07T01:00:00Z» → «2026-09-07».
 *
 * ⚠️ Считаем день ПО КАЗАХСТАНУ, а не по поясу браузера. Сервер возвращает
 * время в UTC, и 6 утра по Казахстану — это 01:00 того же дня по UTC; но у
 * администратора, скажем, в Лондоне наивное чтение дало бы верный день только
 * по счастливой случайности.
 */
export function startToDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) {
    // Значение не разобралось — отдаём первые десять знаков, если они похожи
    // на дату. Лучше показать день, чем пустое поле: пустое поле означает
    // «обучение уже идёт», а это совсем другой смысл.
    return /^\d{4}-\d{2}-\d{2}/.test(iso) ? iso.slice(0, 10) : '';
  }
  // Сдвигаем на пять часов и читаем дату в UTC — это и есть день по Казахстану.
  const kz = new Date(t.getTime() + KZ_OFFSET_HOURS * 60 * 60 * 1000);
  return kz.toISOString().slice(0, 10);
}
